var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-info-component" }, [
    _vm.brandKey === "qcasino"
      ? _c("div", { staticClass: "acc-profile-header" }, [
          _c("img", {
            attrs: {
              src: _vm.mediaServer(
                "/static/brand-img/" + _vm.brandKey + "/logo-white.png"
              ),
              alt: _vm.brandKey
            },
            on: {
              click: function($event) {
                return _vm.closeMyAccountDialog()
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "user_details" }, [
      _c("div", { staticClass: "user_details_name" }, [
        _c(
          "div",
          { staticClass: "user_image" },
          [_c("v-icon", [_vm._v("account_circle")])],
          1
        ),
        _vm._v(" "),
        _vm.brandKey === "qcasino"
          ? _c("p", { staticClass: "user_profile_title" }, [
              _vm._v(_vm._s(_vm.$t("MyAccount.Profile.Title")))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "user_title" }, [
          _vm._v(
            _vm._s(_vm.customerContext.Name && _vm.customerContext.Name[0]) +
              " " +
              _vm._s(_vm.customerContext.Name[1]) +
              "\n        "
          ),
          _vm.brandKey === "mav"
            ? _c("div", { staticClass: "accountnumber accountnumber--mav" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.AccountNumber")))]),
                _vm._v(" " + _vm._s(_vm.accountNumber || "--"))
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.brandLayout === "generic"
      ? _c("div", { staticClass: "sessionDetails" }, [
          _c("p", { staticClass: "accountnumber" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.AccountNumber")))]),
            _vm._v(" " + _vm._s(_vm.accountNumber || "--"))
          ]),
          _vm._v(" "),
          _vm.state !== "NJ"
            ? _c("p", { staticClass: "sessionDuration sessiondur" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.SessionTime")))]),
                _vm._v(" " + _vm._s(_vm.sessionTime))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "NJ"
            ? _c("p", { staticClass: "sessionDuration sessiondur" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("MyAccount.SessionTime." + _vm.state)))
                ]),
                _vm._v(" " + _vm._s(_vm.sessionTime))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "lastlogin lastlogdur" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LastLogin")))]),
            _vm._v(" " + _vm._s(_vm.lastLogin))
          ]),
          _vm._v(" "),
          _vm.state === "NJ"
            ? _c("p", { staticClass: "current-time" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.CurrentTime")))]),
                _vm._v(" " + _vm._s(_vm.currentTime))
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.brandKey === "sb" ||
    _vm.brandKey === "mav" ||
    _vm.brandKey === "qcasino"
      ? _c(
          "div",
          {
            staticClass: "sessionDetails",
            class: "sessionDetails--" + _vm.brandKey
          },
          [
            _vm.brandKey !== "mav" && _vm.brandKey !== "qcasino"
              ? _c("p", { staticClass: "accountnumber" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("MyAccount.AccountNumber")))
                  ]),
                  _vm._v(" " + _vm._s(_vm.accountNumber || "--"))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey !== "mav" && _vm.state !== "NJ"
              ? _c("p", { staticClass: "sessionDuration sessiondur" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.SessionTime")))]),
                  _vm._v(" " + _vm._s(_vm.sessionTime))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey !== "mav" && _vm.state === "NJ"
              ? _c("p", { staticClass: "sessionDuration sessiondur" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("MyAccount.SessionTime." + _vm.state)))
                  ]),
                  _vm._v(" " + _vm._s(_vm.sessionTime))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey !== "mav"
              ? _c("p", { staticClass: "lastlogin lastlogdur" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LastLogin")))]),
                  _vm._v(" " + _vm._s(_vm.lastLogin))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey === "mav"
              ? _c("p", { staticClass: "sessionDuration sessiondur" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.SessionTime")))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.sessionTime))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey === "mav"
              ? _c("p", { staticClass: "lastlogin lastlogdur" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LastLogin")))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.lastLogin))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.state === "NJ"
              ? _c("p", { staticClass: "current-time" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.CurrentTime")))]),
                  _vm._v(" " + _vm._s(_vm.currentTime))
                ])
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "account_balance" },
      [
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              {
                staticClass: "balance",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.refreshAccountsDetails()
                  }
                }
              },
              [
                _c("div", { staticClass: "balance_holder" }, [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.$t("MyAccount.TotalCash")))
                  ]),
                  _vm._v(" "),
                  !_vm.balanceLoader
                    ? _c(
                        "span",
                        {
                          staticClass: "value",
                          attrs: { id: "sportbook-balance" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("currency")(_vm.balanceSum || 0))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.balanceLoader
                    ? _c(
                        "div",
                        { staticClass: "loading" },
                        [_c("dots-loader")],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.promoBalanceSum
                  ? _c("div", { staticClass: "balance_holder" }, [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("MyAccount.PromoBalance")))
                      ]),
                      _vm._v(" "),
                      !_vm.balanceLoader
                        ? _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(_vm.promoBalanceSum || 0)
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.balanceLoader
                        ? _c(
                            "div",
                            { staticClass: "loading" },
                            [_c("dots-loader")],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.brandLayout !== "generic" &&
    _vm.brandKey !== "sb" &&
    _vm.brandKey !== "mav" &&
    _vm.brandKey !== "qcasino"
      ? _c("div", { staticClass: "sessionDetails" }, [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.brandKey !== "rw",
                  expression: "brandKey !== 'rw'"
                }
              ],
              staticClass: "accountnumber"
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.AccountNumber")))]),
              _vm._v(" " + _vm._s(_vm.accountNumber || "--"))
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "sessionDuration" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.SessionTime")))]),
            _vm._v(" " + _vm._s(_vm.sessionTime))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "lastlogin" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LastLogin")))]),
            _vm._v(" " + _vm._s(_vm.lastLogin))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e0d5b94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e0d5b94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountInfoComponent.vue
// module id = null
// module chunks = 